var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShutter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "orange",
    height: "188px",
    width: "188px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-49.24 -49.24 590.86 590.86",
    xmlSpace: "preserve",
    stroke: "orange",
    strokeWidth: 19.69512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -49.24,
    y: -49.24,
    width: 590.86,
    height: 590.86,
    rx: 295.43,
    fill: "#000",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.984756
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M327.606,14.073C302.091,5.11,274.774,0,246.216,0c-23.099,0-45.359,3.417-66.568,9.363l0.018,152.669L327.606,14.073z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.235,140.417c-21.582-45.224-56.443-82.795-99.674-107.648L260.913,140.417H468.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.249,169.751c-7.865,24.08-12.247,49.726-12.247,76.415c0,24.465,3.69,48.044,10.328,70.353h148.706L12.249,169.751z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.753,466.411c43.773-21.838,80.117-56.199,104.273-98.557L355.753,263.571V466.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.786,182.597H334.424l144.19,144.156c8.766-25.272,13.762-52.316,13.762-80.587 C492.376,224.149,489.22,202.905,483.786,182.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.382,480.355c23.903,7.735,49.352,12.022,75.834,12.022c23.387,0,45.918-3.482,67.357-9.572V337.134L170.382,480.355z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.399,358.716c22.632,43.887,57.896,80.182,101.174,103.781l103.778-103.781H27.399z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.453,25.579c-45.39,22.42-82.975,58.2-107.247,102.476l107.247,107.247V25.579z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutter);
export default __webpack_public_path__ + "static/media/shutter.7f84be524e8ac6fdd7805da1cf0ebbfc.svg";
export { ForwardRef as ReactComponent };